import Vue from 'vue'
import Vuex from 'vuex'
import apiClient from '@/services/axios'
import router from '@/router'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async BUY_COURSE(_, { dataCourse: courseArr }) {
      try {
        const urlSource = router.history.current.fullPath
        const { data: { data } } = await apiClient.post('/xendit/payment', { courseArr, urlSource })
        return new Promise((resolve, reject) => {
          resolve(data.invoice_url)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async GET_USER_TRANSACTION_HISTORY(_, { status }) {
      try {
        const { data: { data } } = await apiClient.get('/transaction/history', { params: { status } })
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
  },
  modules: {
  },
  getters: {},
}
